module.exports = __webpack_public_path__ + "static/media/undraw_chilling_8tii.816ade2c.svg";